import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export type DownloadSelectionProps = {
  open: boolean;
  title?: string;
  description?: React.ReactNode;
  onClose: () => void;
  onSingleDownload: () => void;
  onMultipleDownload: () => void;
  singleLabel?: string;
  multipleLabel?: string;
};

export function DownloadSelection({
  open,
  title = 'Download',
  description,
  onClose,
  onSingleDownload,
  onMultipleDownload,
  singleLabel = 'Single Download',
  multipleLabel = 'Multiple Download',
}: DownloadSelectionProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pr: 5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          <Box sx={{ ml: 'auto' }}>
            <IconButton size="small" onClick={onClose} aria-label="cancel">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        {description != null ? (
          <Box sx={{ mb: 1.5 }}>{description}</Box>
        ) : (
          <Typography sx={{ mb: 1.5 }}>Please choose download type.</Typography>
        )}

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            size="small"
            variant="contained"
            onClick={onMultipleDownload}
            sx={{
              minWidth: 0,
              px: 1,
              py: 0.25,
              fontSize: 12,
              lineHeight: 2.4,
            }}
          >
            {multipleLabel}
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={onSingleDownload}
            sx={{
              minWidth: 0,
              px: 1,
              py: 0.25,
              fontSize: 12,
              lineHeight: 2.4,
            }}
          >
            {singleLabel}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
